import $ from "jquery";
import "slick-carousel";

class Carousel {
	run() {
        this.ready();
    }
    ready(){
       
        $('.slider-single-article').not('.slick-initialized').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true,
        });
        $('.container-slide').not('.slick-initialized').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            arrows: false,
            dots:true,
            responsive: [
                {
                  breakpoint:769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    centerMode: false,
                  }
                }
            ]
        });
        $('.container-reference').not('.slick-initialized').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 5,
            slidesToScroll: 5,
            arrows: false,
            dots:true,
            responsive: [
                {
                  breakpoint:769,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true,
                    centerMode: false,
                  }
                }
            ]
        });
        $('#carousel-case-study-list .container-slides, #case-study-featured .container-slides').not('.slick-initialized').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots:true,
            responsive: [
                {
                  breakpoint:960,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    centerMode: false,
                  }
                },
                {
                  breakpoint:769,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    centerMode: false,
                  }
                },
            ]
        });
    }
}

const carousel = new Carousel();
export default carousel;
